import { toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { v4 } from 'uuid';
import { LayoutType } from '../../../types/layouts.esm.js';
import { createSelector } from 'reselect';
import { createSortedDisplayLayoutsSelector } from './sorted-display-layouts-selector.esm.js';
import { trim } from '../../../utilities/trim.esm.js';
import { sortLayouts } from '../../../utilities/sort-layouts.esm.js';
import { keys } from '../../../constants/keys.esm.js';

var getLayoutSelectOptions = function getLayoutSelectOptions(resources, layouts) {
  if (!layouts) {
    return [];
  }
  var custom = {
    id: keys.custom,
    label: resources.custom(),
    group: '',
    type: LayoutType.Custom
  };
  var result = sortLayouts(layouts).reduce(function (acc, item) {
    var label = trim(item.label);
    var id = item.id || v4();
    switch (item.type) {
      case LayoutType.Default:
        {
          label = label || resources["default"]();
          id = keys["default"];
          return [{
            label: label,
            id: id,
            group: '',
            type: item.type
          }].concat(_toConsumableArray(acc));
        }
      case LayoutType.Predefined:
        {
          if (label === undefined) {
            throw new Error('Label cannot be undefined');
          }
          var group = resources.predefined();
          return [].concat(_toConsumableArray(acc), [{
            group: group,
            id: id,
            label: label,
            type: item.type
          }]);
        }
      case LayoutType.Saved:
        {
          if (label === undefined) {
            throw new Error('Label cannot be undefined');
          }
          var _group = resources.saved();
          return [].concat(_toConsumableArray(acc), [{
            group: _group,
            id: id,
            label: label,
            type: item.type
          }]);
        }
      default:
        return acc;
    }
  }, [custom]);
  return result;
};
var createLayoutListOptionsSelector = function createLayoutListOptionsSelector() {
  var sortedDisplayLayoutsSelector = createSortedDisplayLayoutsSelector();
  return createSelector(function (props) {
    return props.resources.layouts;
  }, sortedDisplayLayoutsSelector, getLayoutSelectOptions);
};

export { createLayoutListOptionsSelector, getLayoutSelectOptions };
//# sourceMappingURL=layout-list-options-selector.esm.js.map
